import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { getIncrementalTable } from "../../../Requests/deltaHedgeSettings";
import {
  IDeltaHedgeTablesSearchParam,
  IIncrementalTableReport,
} from "../../../Interfaces/deltaHedgeSettings";
import { Additional } from "./Additional";
import TableUI from "./TableUI";

interface IProps {
  searchParams: IDeltaHedgeTablesSearchParam;
}

const IncrementalTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IDeltaHedgeTablesSearchParam, IIncrementalTableReport>
      TableUI={({ reports, onAction }) => (
        <TableUI
          reports={reports}
          onAction={onAction}
          AdditionalBody={Additional}
        />
      )}
      getDataTable={getIncrementalTable}
      searchParameters={searchParams}
    />
  );
};

export default IncrementalTable;
